import {
  LOADING_GET_REPORTS,
  CONFIRMED_GET_REPORTS,
  FAILED_GET_REPORTS,
  LOADING_SEND_REPORT_LINK,
  CONFIRMED_SEND_REPORT_LINK,
  FAILED_SEND_REPORT_LINK,
  LOADING_UPLOAD_REPORT,
  CONFIRMED_UPLOAD_REPORT,
  FAILED_UPLOAD_REPORT,
  LOADING_EDIT_REPORT,
  CONFIRMED_EDIT_REPORT,
  FAILED_EDIT_REPORT,
  LOADING_DELETE_REPORT,
  CONFIRMED_DELETE_REPORT,
  FAILED_DELETE_REPORT
} from "./ReportTypes";

import {
  getReports,
  sendReportLink,
  uploadReport,
  editReport,
  deleteReport,
  deleteReportFile
} from "../../services/ReportService";
import {
  handleError,
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService";

// Get token from Redux or fallback to localStorage
function getAuthToken(getState) {
  const token = localStorage.getItem("token");
  return token;
}

// Get Reports Action
export function getReportsAction(patientId, searchTerm = "") {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADING_GET_REPORTS });

      const response = await getReports(patientId, searchTerm);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_REPORTS,
          payload: response.data.data,
          search: searchTerm,
        });
      } else {
        dispatch({
          type: FAILED_GET_REPORTS,
          payload: "Failed to get reports",
        });
        handleError("Failed to get reports");
      }
    } catch (error) {
      console.error("Get reports error:", error);
      dispatch({
        type: FAILED_GET_REPORTS,
        payload: error.message || "Failed to get reports",
      });
      handleError(error.message || "Failed to get reports");
    }
  };
}

// Send Report Link Action
export function sendReportLinkAction(linkData) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADING_SEND_REPORT_LINK });

      const response = await sendReportLink(linkData);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_SEND_REPORT_LINK,
          payload: response.data.data,
        });
        handleSuccess("Report link sent successfully!");
      } else {
        dispatch({
          type: FAILED_SEND_REPORT_LINK,
          payload: "Failed to send report link",
        });
        handleError("Failed to send report link");
      }
    } catch (error) {
      console.error("Send report link error:", error);
      dispatch({
        type: FAILED_SEND_REPORT_LINK,
        payload: error.message || "Failed to send report link",
      });
      handleError(error.message || "Failed to send report link");
      throw error;
    }
  };
}

// Upload Report Action
export function uploadReportAction(formData) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADING_UPLOAD_REPORT });

      const response = await uploadReport(formData);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_UPLOAD_REPORT,
          payload: response.data.data,
        });
        handleSuccess("Report uploaded successfully!");
        return response;
      } else {
        dispatch({
          type: FAILED_UPLOAD_REPORT,
          payload: "Failed to upload report",
        });
        handleError("Failed to upload report");
      }
    } catch (error) {
      console.error("Upload report error:", error);
      dispatch({
        type: FAILED_UPLOAD_REPORT,
        payload: error.message || "Failed to upload report",
      });
      handleError(error.message || "Failed to upload report");
      throw error;
    }
  };
}


export function editReportAction(formData) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADING_EDIT_REPORT });

      const response = await editReport(formData);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_EDIT_REPORT,
          payload: response.data.data,
        });
        handleSuccess("Report updated successfully!");
        return response;
      } else {
        dispatch({
          type: FAILED_EDIT_REPORT,
          payload: "Failed to update report",
        });
        handleError("Failed to update report");
      }
    } catch (error) {
      dispatch({
        type: FAILED_EDIT_REPORT,
        payload: error.message,
      });
      handleError(error.message);
      throw error;
    }
  };
}

export function deleteReportAction(reportId) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADING_DELETE_REPORT });

      const response = await deleteReport(reportId);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_DELETE_REPORT,
          payload: reportId,
        });
        handleSuccess("Report deleted successfully!");
        return response;
      } else {
        dispatch({
          type: FAILED_DELETE_REPORT,
          payload: "Failed to delete report",
        });
        handleError("Failed to delete report");
      }
    } catch (error) {
      dispatch({
        type: FAILED_DELETE_REPORT,
        payload: error.message,
      });
      handleError(error.message);
      throw error;
    }
  };
}

export function deleteReportFileAction(report_file_id) {
  return async (dispatch) => {
    try {
      const response = await deleteReportFile(report_file_id);

      if (response?.data?.status === "success") {
        return response;
      } else {
        throw new Error("Delete failed");
      }
    } catch (error) {
      console.error("Delete file error:", error);
      throw error;
    }
  };
}